import React from "react";

// props: data = array of objects
export const DynamicArrayJsonView = ({ label, value }) => {
    const data = value;

    if (data == null || (data && data.length === 0))
        return (
            <div className="my-4">
                <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
                    {label}
                </h1>
            </div>
        );

    const columns = Object.keys(data[0]);

    const renderCell = (key, value) => {
        console.log("key value", key, value);

        if (typeof value === "object") {
            // If it's an image URL
            if (
                typeof value?.url === "string" &&
                value?.url?.match(/\.(jpg|jpeg|png|gif)$/i)
            ) {
                return (
                    <img
                        src={value.url}
                        alt={value.alt ?? value.url}
                        className="w-14 h-14 object-cover rounded-xl shadow"
                    />
                );
            }

            return <span>{JSON.stringify(value)}</span>;
        }

        // If it's a file URL
        if (
            typeof value === "string" &&
            value.match(/\.(pdf|doc|docx|xls|xlsx)$/i)
        ) {
            return (
                <a
                    href={value}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="text-blue-600 underline"
                >
                    View File
                </a>
            );
        }

        return <span>{JSON.stringify(value)}</span>;
    };

    return (
        <div className="overflow-x-auto p-4">
            <h1 className="text-lightGreyText font-fw_400 text-fs_16 capitalize">
                {label}
            </h1>
            <table className="min-w-full border rounded-2xl overflow-hidden">
                <thead>
                    <tr className="bg-gray-100 text-left">
                        {columns.map((col) => (
                            <th
                                key={col}
                                className="p-3 font-semibold capitalize border-b"
                            >
                                {col}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {data.map((row, idx) => (
                        <tr
                            key={idx}
                            className="border-b hover:bg-gray-50 transition"
                        >
                            {columns.map((col) => (
                                <td key={col} className="p-3">
                                    {renderCell(col, row[col])}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};
